const searchFilters = document.getElementById('ghn-faceted-search');
if (searchFilters) {
  Array.from(searchFilters.querySelectorAll('input[type="checkbox"]'))
    .forEach((checkbox) => checkbox.addEventListener('change', (event) => {
      event.currentTarget.form.submit();
    }));
}
